/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const LicensingUsageReportsPage: React.FC<{}> = () => {
    const xtype = 'rcop.configuration.license.reports';

    return (
        <TabBarBodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </TabBarBodyLayout>
    );
};
